"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FileToBlob = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _blobUtil = require("blob-util");
var _Icon = require("../../Icon");
var _reactstrap = require("reactstrap");
require("./style.css");
class FileToBlob extends _react.default.Component {
  constructor(props) {
    super(props);
    this.state = {
      blobImageUrl: '',
      isLoading: false,
      tooltipOpen: false,
      setDisable: true
    };
  }
  componentDidMount() {
    const {
      sourceUrl
    } = this.props;
    this.getBlobImageUrl(sourceUrl);
  }
  componentDidUpdate(prevProps, prevState) {
    const {
      sourceUrl
    } = this.props;
    if (prevProps.sourceUrl !== sourceUrl) {
      this.getBlobImageUrl(sourceUrl);
    }
  }
  setVideoBlob(videoUrl) {
    const {
      mime
    } = this.props;
    let xhr = new XMLHttpRequest();
    xhr.responseType = 'blob';
    xhr.onload = () => {
      let reader = new FileReader();
      reader.onloadend = () => {
        let byteCharacters = atob(reader.result.slice(reader.result.indexOf(',') + 1));
        let byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        let byteArray = new Uint8Array(byteNumbers);
        let blob = new Blob([byteArray], {
          type: `${mime}`
        });
        let url = URL.createObjectURL(blob);
        this.setState({
          setDisable: false,
          blobImageUrl: url,
          isLoading: false
        });
      };
      reader.readAsDataURL(xhr.response);
    };
    xhr.open('GET', videoUrl);
    xhr.send();
  }
  getBlobImageUrl(sourceUrl) {
    if (sourceUrl) {
      const {
        mime
      } = this.props;
      this.setState({
        isLoading: true
      });
      if (mime.split('/')[0] === 'video') {
        return this.setVideoBlob(sourceUrl);
      } else {
        return (0, _blobUtil.imgSrcToBlob)(sourceUrl, `${mime}`).then(blob => {
          this.setState({
            setDisable: false,
            blobImageUrl: (0, _blobUtil.createObjectURL)(blob),
            isLoading: false
          });
        }).catch(error => {
          this.setState({
            setDisable: true,
            isLoading: false
          });
          return Promise.reject(error);
        });
      }
    }
  }
  toggle() {
    const {
      tooltipOpen
    } = this.state;
    this.setState({
      tooltipOpen: !tooltipOpen
    });
  }
  render() {
    const {
      blobImageUrl,
      isLoading,
      tooltipOpen,
      setDisable
    } = this.state;
    const {
      sourceUrl,
      disabled
    } = this.props;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, isLoading && /*#__PURE__*/_react.default.createElement(_reactstrap.Tooltip, {
      placement: "top",
      isOpen: tooltipOpen,
      target: "ToBlob",
      toggle: this.toggle.bind(this)
    }, "Preparing Download"), /*#__PURE__*/_react.default.createElement("div", {
      id: "ToBlob",
      className: `${isLoading ? 'blob--loading' : ''} ${setDisable || disabled ? 'blob--disabled' : ''}`
    }, /*#__PURE__*/_react.default.createElement("a", {
      href: blobImageUrl,
      download: sourceUrl.substring(sourceUrl.lastIndexOf('/') + 1),
      className: `btn btn-secondary blob--download ${setDisable || disabled ? 'disabled' : ''}`
    }, /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
      icon: ['fas', 'download'],
      size: "1x"
    }))));
  }
}
exports.FileToBlob = FileToBlob;
;
FileToBlob.propTypes = {
  /** Specifies the image URL. */
  sourceUrl: _propTypes.default.string.isRequired,
  /** Specifies mime type.  */
  mime: _propTypes.default.string,
  /** Disbale the download button */
  disabled: _propTypes.default.bool
};